import { Inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import {
  catchError,
  mergeMap,
  switchMap,
  withLatestFrom,
} from 'rxjs/operators';
import {
  IMessagesService,
  MESSAGES_SERVICE,
} from '../../services/IMessages.service';
import * as fromNotificationsActions from '../actions/notifications.actions';
import * as fromActions from '../messages.actions';
import { NotificationsStore } from '../store/notifications.store';

@Injectable()
export class NotificationsEffects {
  getNotifications$ = createEffect(() =>
    this.actions$.pipe(
      ofType(fromNotificationsActions.getNotificationsBeginAction),
      switchMap((action) =>
        this.service.getNotifications().pipe(
          mergeMap((payload) =>
            of([
              fromNotificationsActions.getNotificationsSuccessAction({ payload }),
              fromActions.clearConversationSuccessErrorDataAction(),
            ]).pipe(switchMap((d) => d))
          ),
          catchError((error) => {
            console.error('Could not get Notifications', error);
            return of([
              fromNotificationsActions.getNotificationsFailAction({ errors: error }),
              fromActions.clearConversationSuccessErrorDataAction(),
            ]).pipe(switchMap((d) => d));
          })
        )
      )
    )
  );

  setNotificationAsRead$ = createEffect(() =>
    this.actions$.pipe(
      ofType(fromNotificationsActions.setNotificationAsReadBeginAction),
      withLatestFrom(this.notificStore.data$),
      switchMap(([action, prevState]) =>
        this.service.setNotificationAsRead(action.id).pipe(
          mergeMap((updatedLead) => {
            const payload = [...prevState];
            const idx = payload.findIndex((el) => el.id === action.id);
            payload.splice(idx, 1, updatedLead);

            return of([
              fromNotificationsActions.setNotificationAsReadSuccessAction({ payload }),
              fromActions.clearConversationSuccessErrorDataAction(),
            ]).pipe(switchMap((d) => d));
          }),
          catchError((error) => {
            console.error('Could not set notification as read', error);
            return of([
              fromNotificationsActions.setNotificationAsReadFailAction({ errors: error }),
              fromActions.clearConversationSuccessErrorDataAction(),
            ]).pipe(switchMap((d) => d));
          })
        )
      )
    )
  );

  constructor(
    private actions$: Actions,
    @Inject(MESSAGES_SERVICE) private service: IMessagesService,
    private notificStore: NotificationsStore
  ) {}
}
